import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@/i18n/i18n';
import '@/styles/global.css';
import { AuthContextProvider } from '@/contexts/AuthContext';
import { UserProvider } from '@/contexts/UserContext';
import { ProjectProvider } from '@/contexts/ProjectContext';
import { DeploymentUrlsProvider } from "@/contexts/DeploymentUrlsContext";

let root: ReactDOM.Root;

/**
 * Mount function to render the app
 * @param element - The root element to render the app
 */
export function mountReact(element: HTMLElement) {
  root = ReactDOM.createRoot(element);

  root.render(
    <React.StrictMode>
      <AuthContextProvider>
        <DeploymentUrlsProvider>
          <UserProvider>
            <ProjectProvider>
              <App />
            </ProjectProvider>
          </UserProvider>
        </DeploymentUrlsProvider>
      </AuthContextProvider>
    </React.StrictMode>,
  );
}

if (document.getElementById('react-app-root')) {
  mountReact(document.getElementById('react-app-root') as HTMLElement);
}
